import { sbLink } from "@/lib/storyblok/link";
import type { StoryblokMultilink } from "storyblok";

/** True when a Storyblok `mediaLink` field resolves to an href. Safe to use in server components. */
export const hasMediaLink = (link: unknown) => !!(link && sbLink(link as StoryblokMultilink)?.href);
